// eslint-disable-next-line import/prefer-default-export
export {default as edit} from './Edit'
export const defaultId = 1
